import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const mongodbAtlas = defineConnector({
  identifier: "mongodbAtlas",
  name: "MongoDB Atlas",
  tagLine: "MongoDB cloud database",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://cloud\\.mongodb\\.com/.*",
  auth: customAuth("mongodbAtlas"),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "In MongoDB Atlas, go to **Organization Access Manager > API Keys** and create a new API key with the appropriate roles.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "input",
          label: "Public key",
          required: true,
          target: { kind: "configuration", field: "publicKey" },
        },
        {
          kind: "input",
          label: "Private key",
          required: true,
          target: { kind: "secrets", field: "privateKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://cloud.mongodb.com/api/atlas/v2",
  },
});
